import React from "react";
import { Box } from "@mui/material";

export default function PageContainer({ children, maxWidth = 1280, sx = {} }) {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth,
        minWidth: 0,
        // Without this, `width: 100%` resolves to the full 1200px of
        // available space and then px (32px each side at the md+
        // breakpoint) adds ON TOP of that as extra footprint — this Box
        // was rendering 64px wider than its own parent, the exact
        // remainder left over after PageShell's own flex fix. MUI's
        // global reset normally sets border-box everywhere; setting it
        // explicitly here doesn't depend on that staying true.
        boxSizing: "border-box",
        mx: "auto",
        px: { xs: 2, sm: 3, md: 4 },
        pt: { xs: 1.5, md: 2 },
        pb: { xs: 3, md: 4 },
        display: "flex",
        flexDirection: "column",
        gap: 2,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
